/*=========================================================================================
  File Name: moduleRequestTypeActions.js
  Description: Request Type Module Actions

==========================================================================================*/
import requestGQL from "@/http/requests/request";

export default {
	getRequestTypes({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.getRequestTypes(payload)
				.then(response => {
					commit("SET_REQUEST_TYPES", response.data);
					commit("SET_TOTAL_REQUEST_TYPES", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getRequestType({ commit }, id, list_all_control) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.getRequestType(id, list_all_control)
				.then(response => {
					commit("UPDATE_REQUEST_TYPE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getRequestTypeSimpleData({ commit }, id) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.getRequestTypeSimpleData(id)
				.then(response => {
					commit("UPDATE_REQUEST_TYPE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addRequestType({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.addRequestType(payload)
				.then(response => {
					commit("ADD_REQUEST_TYPE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateRequestType({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.updateRequestType(payload)
				.then(response => {
					commit("UPDATE_REQUEST_TYPE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteRequestType({ state, commit }, id) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.deleteRequestType(id)
				.then(response => {
					commit("DELETE_REQUEST_TYPE", id);
					commit("SET_TOTAL_REQUEST_TYPES", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
